/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { DomainItemDTO } from '@api/models/.';
import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { DomainValuePipe } from '../../pipes/domain-value/domain-value.pipe';

@Component({
  selector: 'app-modal-search',
  templateUrl: './modal-search.component.html',
  styleUrls: ['./modal-search.component.scss'],
  providers: [DomainValuePipe]
})
export class ModalSearchComponent implements OnInit, AfterViewInit {
  @ViewChild('searchbar') searchbar: IonSearchbar;

  /**
   * lista di options
   */
  @Input() options: DomainItemDTO[] = [];

  /**
   * valore iniziale di ricerca
   */
  @Input() value: string;

  /**
   * model per campo di ricerca
   */
  searchText: string;

  /**
   * numero massimo di risultati visibili
   */
  readonly maxVisibleResults = 200;

  constructor(
    private modalController: ModalController,
    private domainValuePipe: DomainValuePipe
  ) {}

  ngOnInit() {
    this.initSearchText();
  }

  ngAfterViewInit() {
    // applico con delay per attendere la fine dell'animazione di apertura della modale
    setTimeout(() => {
      this.searchbar.setFocus();
    }, 400);
  }

  /**
   * seleziona l'option e chiude la modale
   */
  selectOption(key: string): void {
    const option = this.options.find(x => x.key === key);

    if (!option) {
      return;
    }

    this.modalController.dismiss({ action: 'select', option: { ...option } });
  }

  /**
   * deseleziona la scelta
   */
  deleteSelect(): void {
    this.modalController.dismiss({ action: 'delete' });
  }

  /**
   * chiude la modale
   */
  close(): void {
    this.modalController.dismiss();
  }

  /**
   * imposta il valore iniziale del search text
   */
  private initSearchText(): void {
    if (!this.value) {
      return;
    }

    this.searchText = this.domainValuePipe.transform(this.value, this.options);
  }
}
